import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import ImageAnnotationTool from '../videoPage/ImageAnnotationTool';
import RightBar from '../videoPage/RightBar';
import SideBar from '../sideBar';
import { IS_ANNOTATION } from 'store/actions';
// import ReactApexChart from 'react-apexcharts';
import EvidenceVideo from './EvidenceVideo';
import 'chart.js/auto';
import DatePickerStore from '../Calendar';
// import ReactApexChart from 'react-apexcharts';
// import EvidenceList from './evidenceList';

const EvidencePage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const targetRef = useRef(null);
  const [source, setSource] = useState('');
  const [isRightBarVisible] = useState(true);
  const isAnnotation = useSelector((state) => state.cameraReducer.isAnnotation);
  const checkImage = useSelector((state) => state.cameraReducer.checkImage);
  const currentDate = useSelector((state) => state.customization.currentDate);

  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  const videoRef = useRef(null);
  const [videoData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  // const [selectedVideo, setSelectedVideo] = useState(null);
  // const [thumbnails, setThumbnails] = useState({});
  const selectedSource = useSelector((state) => state.customization.videoSource);

  useEffect(() => {
    if (checkImage) {
      dispatch({ type: IS_ANNOTATION, isAnnotation: true });
    }
  }, [checkImage, dispatch]);

  // fetch video list
  // const fetchVideoData = async (date, device) => {
  //   const r = await fetch('https://neoe2e.neophyte.live/fm-api/kpiCreation/evidenceList', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ date, device })
  //   });
  //   const data = await r.json();
  //   setVideoData(Array.isArray(data) ? data : []);
  //   if (data?.[0]?.videos) setSource(`${data[0].videos}`);
  // };

  // fetch graph points
  const fetchGraphData = async (date, device) => {
    try {
      console.log('Fetching data from API...');

      const response = await fetch('https://neoe2e.neophyte.live/fm/v2/evidenceVideo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, device })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const rawData = await response.json();

      // Check if rawData is an array
      if (!Array.isArray(rawData)) {
        console.error('API response is not an array:', rawData);
        throw new Error('Invalid API response: Expected an array');
      }

      console.log(`API Response Received: ${rawData.length} records`);

      // Log the first few records safely
      console.log('Sample Response:', JSON.stringify(rawData.slice(0, 3), null, 2));

      const formattedData = rawData.flatMap((item, index) => {
        if (!Array.isArray(item.label_wise)) {
          console.warn(`Skipping item at index ${index}, missing "label_wise":`, item);
          return [];
        }

        return item.label_wise
          .map((labelData, labelIndex) => {
            if (!labelData.label || !labelData.track_ids || !Array.isArray(labelData.track_ids)) {
              console.warn(`Skipping label at index ${labelIndex}, invalid data:`, labelData);
              return null;
            }

            return {
              x: new Date(labelData.time).getTime(),
              y: labelData.track_ids.length,
              label: labelData.label,
              trackIds: labelData.track_ids
            };
          })
          .filter(Boolean);
      });

      console.log('Formatted Data:', JSON.stringify(formattedData.slice(0, 5), null, 2));

      setGraphData(formattedData);
    } catch (error) {
      console.error('Error fetching graph data:', error);
    }
  };

  useEffect(() => {
    if (currentDate && selectedCamera.device_name) {
      console.log(`Fetching data for date: ${currentDate}, camera: ${selectedCamera.device_name}`);
      // fetchVideoData(currentDate, selectedCamera.device_name);
      fetchGraphData(currentDate, selectedCamera.device_name);
    }
  }, [currentDate, selectedCamera.device_name]);

  // const colorMap = {
  //   Car: '#007BFF', // Blue
  //   EmployeePerson: '#4CAF50', // Green
  //   GuardPerson: '#FF9800', // Orange
  //   Helmet: '#FF1744', // Bright Red
  //   HelmetPerson: '#9C27B0', // Purple
  //   Human: '#008080', // Teal
  //   ManualMhe: '#26A69A', // Aqua Green
  //   OrangeEngineMhe: '#FF5722', // Deep Orange
  //   OtherPerson: '#D32F2F', // Dark Red
  //   Palettes: '#6A1B9A', // Dark Purple
  //   PpeKit: '#1976D2', // Deep Blue
  //   PpePerson: '#388E3C', // Forest Green
  //   ProductBoxes: '#FBC02D', // Golden Yellow
  //   ShutterClose: '#E64A19', // Burnt Orange
  //   ShutterOpen: '#673AB7', // Deep Violet
  //   Truck: '#5D4037', // Brown
  //   YellowEngineMhe: '#CDDC39', // Lime
  //   Default: '#9E9E9E' // Gray
  // };

  // const chartOptions = {
  //   chart: {
  //     type: 'area',
  //     height: 350,
  //     toolbar: { show: false },
  //     zoom: { enabled: true }
  //   },
  //   dataLabels: { enabled: false },
  //   stroke: { curve: 'smooth', width: 2 },
  //   markers: {
  //     size: 6,
  //     strokeColors: '#fff',
  //     strokeWidth: 2,
  //     hover: { size: 8 }
  //   },
  //   xaxis: {
  //     type: 'datetime',
  //     title: {
  //       text: 'Timestamp',
  //       style: { fontSize: '12px', fontWeight: 500, color: '#000000' }
  //     },
  //     labels: { style: { colors: '#000000' } }
  //   },
  //   yaxis: {
  //     title: {
  //       text: 'Number of Track IDs',
  //       style: { fontSize: '12px', fontWeight: 500, color: '#000000' }
  //     },
  //     min: 0,
  //     tickAmount: 5,
  //     labels: { style: { colors: '#000000' } }
  //   },
  //   tooltip: {
  //     shared: false,
  //     custom: ({ seriesIndex, dataPointIndex, w }) => {
  //       const data = w.config.series[seriesIndex].data[dataPointIndex];

  //       return `
  //     <div style="
  //       background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  //       color: #333;
  //       font-size: 14px;
  //       font-weight: 500;
  //       padding: 14px;
  //       border-radius: 12px;
  //       box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
  //       border: 1px solid #e0e4e7;
  //       text-align: left;
  //       min-width: 180px;
  //       transition: all 0.3s ease-in-out;
  //       position: relative;
  //     ">
  //       <!-- Tooltip Header -->
  //       <div style="
  //         border-bottom: 2px solid #4f46e5;
  //         padding-bottom: 8px;
  //         margin-bottom: 8px;
  //         font-size: 16px;
  //         font-weight: bold;
  //         color: #4f46e5;
  //         text-transform: uppercase;
  //         display: flex;
  //         align-items: center;
  //         gap: 8px;
  //       ">
  //         <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #4f46e5;"></span>
  //         ${data.label}
  //       </div>

  //       <!-- Tooltip Content -->
  //       <div style="
  //         display: flex;
  //         justify-content: space-between;
  //         align-items: center;
  //         padding: 6px 0;
  //         border-radius: 6px;
  //         background: rgba(16, 185, 129, 0.1);
  //         color: #10b981;
  //         font-weight: bold;
  //         padding: 10px;
  //       ">
  //         <span style="color: #6b7280; font-size: 13px;">Track IDs Count:</span>
  //         <span>${data.trackIds.length}</span>
  //       </div>

  //       <!-- Tooltip Arrow -->
  //       <div style="
  //         position: absolute;
  //         bottom: -8px;
  //         left: 50%;
  //         transform: translateX(-50%);
  //         width: 0;
  //         height: 0;
  //         border-left: 8px solid transparent;
  //         border-right: 8px solid transparent;
  //         border-top: 8px solid #e0e4e7;
  //       "></div>
  //     </div>`;
  //     }
  //   },

  //   grid: {
  //     borderColor: '#e0e0e0',
  //     row: { colors: ['transparent', 'transparent'], opacity: 0.5 }
  //   },
  //   theme: { mode: 'light' }
  // };

  const capitalizeLabel = (label) => {
    if (!label) return 'Unknown';

    return label
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  };

  // Process graph data with memoization
  const groupedData = {};
  graphData.forEach((data) => {
    if (!data.label) return;

    const capitalizedLabel = capitalizeLabel(data.label);

    if (!groupedData[capitalizedLabel]) {
      groupedData[capitalizedLabel] = [];
    }
    groupedData[capitalizedLabel].push({
      x: data.x,
      y: data.y,
      label: capitalizedLabel,
      trackIds: data.trackIds
    });
  });

  // const chartSeries = Object.keys(groupedData).map((label) => {
  //   const color = colorMap[label] || colorMap.Default;

  //   return {
  //     name: label,
  //     data: groupedData[label],
  //     color: color
  //   };
  // });

  return (
    <div style={{ position: 'relative', top: '-30px', right: '20px', zIndex: 10 }}>
      <DatePickerStore
        sx={{
          '& .MuiInputBase-root': {
            height: '40px',
            fontSize: { xs: '0.75rem', sm: '0.75rem', xl: '1rem' },
            width: { xs: '120px', sm: '120px', xl: '160px' },
            backgroundColor: '#5A5A5A',
            color: 'white',
            borderRadius: '6px',
            border: '1px solid #6A6A6A',
            '&:hover': {
              backgroundColor: '#6A6A6A'
            }
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#777'
          },
          '& .MuiInputBase-input': {
            color: 'white'
          },
          '& .MuiSvgIcon-root': {
            color: 'white'
          }
        }}
      />
      <div style={{ display: 'flex', backgroundColor: theme.palette.background.default, height: '100vh' }}>
        <SideBar selField="videos" />

        <div
          style={{
            flexGrow: 1,
            marginLeft: '40px',
            width: isRightBarVisible ? '75%' : '100%',
            transition: 'width 0.3s ease',
            position: 'relative'
          }}
        >
          <div className="flex gap-2 w-full mb-3">
            <div className="w-full">
              <div ref={targetRef} className="w-full m-0 p-0">
                {isAnnotation ? (
                  <ImageAnnotationTool />
                ) : (
                  <EvidenceVideo key={selectedSource} vdoSource={source} videoList={videoData} setSource={setSource} ref={videoRef} />
                )}
              </div>
              <div className="flex mt-2 gap-1 mb-1 text-white">
                <div className="w-full h-[372px] rounded-lg p-3">
                  {/* <div className="mt-4">
                    <ReactApexChart options={chartOptions} series={chartSeries} type="area" height={380} width="100%" />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {isRightBarVisible && (
          <div className="w-1/4" style={{ transition: 'transform 0.3s ease', backgroundColor: theme.palette.background.paper }}>
            <RightBar videoSource={setSource} />
          </div>
        )}
      </div>
    </div>
  );
};

export default EvidencePage;
